import { useContext } from 'react'
import { observer } from 'mobx-react'
import { ExpandedRemark, ListTableContext } from 'src/components'

const ListTableFooter = () => {
  const state = useContext(ListTableContext)

  return (
    <ExpandedRemark
      expanded={state?.tableConfig?.Nav_Form?.REMARK_EXPAND}
      remark={state?.tableConfig?.Nav_Form?.REMARK}
    />
  )
}

export default observer(ListTableFooter)